import { Link } from "react-router-dom";
import {useDivision} from "./shared"

type Props = {
  shippingAggregates: readonly string[]
}

export function ShippingAggregationButtons({shippingAggregates}: Props) {
  const division = useDivision()
  return <div className="shippingButtons">
      {shippingAggregates.map(
        shipping =>
          <Link className="shippingButton" key={shipping}
            to={`/division/${division}/POEditor/`
              + `shippingAggregate/${shipping}`} >
            <button>{shipping}</button>
          </Link>
      )}
    </div>
}
